// import products from "@/services";
import { products, store } from "@/services";

/**
 * Modulo control de layout aplicacion
 */

const state = {
  products: [],
  filterProduct: [],
  selectProduct: {},
  brands: [],
  pagination: {},
};

const getters = {
  ITEMS_PRODUCTS(state) {
    return state.products;
  },

  GET_SELECTED_PRODUCT(state) {
    return state.selectProduct;
  },

  GET_PAGINATION: (state) => state.pagination,
};

const mutations = {
  SET_ITEM_PRODUCT(state, payload) {
    state.products = payload;
  },

  SET_FILTER_PRODUCT(state, payload) {
    state.filterProduct = payload;
  },

  SET_ONE_PRODUCT(state, payload) {
    state.selectProduct = payload;
  },

  SET_ALL_BRANDS(state, payload) {
    state.brands = payload;
  },

  SET_PAGINATION(state, payload) {
    state.pagination = payload;
  },
};

const actions = {
  async INDEX({ commit }, payload) {
    try {
      const response = await store.get(
        `api/b2b/publications?page=${payload.page}&per_page=${
          payload.per_page
        }&paginate=${payload.paginate}&search=${payload.search ||
          ""}&brand_id=${payload.brand_id || ""}`
      );
      commit("SET_ITEM_PRODUCT", response.data.data.data);
      commit("SET_PAGINATION", {
        lastPage: response.data.data.lastPage,
        page: response.data.data.page,
        perPage: response.data.data.perPage,
        total: response.data.data.total,
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // OBTENER TODAS LA MARCAS
  async BRANDS({ commit }) {
    try {
      const response = await store.get(`api/b2b/brands`);
      commit("SET_ALL_BRANDS", response.data.data);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  // OBTENER TODAS LAS TIENDAS
  async GET_STORE(_, payload) {
    try {
      const response = await store.get(
        `api/store?page=${payload.page}&per_page=${payload.per_page}&name=${
          payload?.name ? payload.name : ""
        }&store_id=${payload?.store_id ? payload.store_id : ""}&paginate=${
          payload.paginate
        }`
      );
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  //DETAILS PRODUCT
  async SELECT_PRODUCT({ commit }, payload) {
    try {
      const response = await store.get(
        `api/b2b/publications_detail/${payload.id}`
      );
      commit("SET_ONE_PRODUCT", response.data.data);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // HANDLER NEXT AND PREV PAGE
  async HANDLER_PAGE({ commit }, payload) {
    try {
      const response = await products.post(`${payload.url}`, payload);
      commit("SET_ITEM_PRODUCT", response.data.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async FILTER({ commit }, payload) {
    try {
      const response = await products.post(
        `posts_b2b/${payload.limit}`,
        payload
      );
      commit("SET_ITEM_PRODUCT", response.data.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  //CONFIRM PRODUCTS
  async CONFIRM_PRODUCTS_CART(_, payload) {
    try {
      const response = await store.post("api/shooping_carts/check", payload);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_CATALOG_PRODUCTS({ commit }, payload) {
    try {
      const response = await store.get(
        `/api/b2b/publications/storefronts-catalogs?page=${
          payload.page
        }&per_page=${payload.per_page}&paginate=${payload.paginate}${
          payload.brands?.length
            ? "&brands=" + JSON.stringify(payload.brands)
            : ""
        }&search=${payload.search}`
      );
      commit("SET_ITEM_PRODUCT", response.data.publications);
      commit("SET_PAGINATION", {
        lastPage: response.data.lastPage,
        page: response.data.page,
        perPage: response.data.perPage,
        total: response.data.total,
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_PRODUCT_DETAILS({ commit }, payload) {
    try {
      const response = await store.get(
        `/api/b2b/publications/storefronts-details/${payload.publication_id}`
      );
      commit("SET_ONE_PRODUCT", response.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export const product = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
